export const NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_BTN_QA_NAME =
  'newsboardPostProfileEditMessageBtn'
